<template>
  <div class="campaign-referral-jam-prompt d-flex flex-column">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center my-2">
      <b-btn class="pl-0" :to="joinLink" variant="link">
        <h4 class="font-weight-bold text-left m-0">{{ event.title }}</h4>
      </b-btn>

      <div v-if="eventHasEnded">
        <strong>Ended at:</strong> {{ event.endDate | formatDate('Do MMMM YYYY, HH:mm') }}
      </div>
      <div v-else-if="eventHasStarted">
        <strong>Ends in:</strong> {{ eventEndsIn }}
      </div>
      <div v-else-if="event.startDate">
        <strong>Starts in:</strong> {{ eventStartsIn }}
      </div>
    </div>
    <b-btn class="text-left w-100" :to="joinLink" variant="primary">
      Join Jam
    </b-btn>
  </div>
</template>

<script>
import eventsMixin from '@src/mixins/events';

export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  mixins: [
    eventsMixin,
  ],
  computed: {
    joinLink() {
      return { name: 'EventPage', params: { eventID: this.eventHandle } };
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-dashboard/ReferralJamCard.vue